export default {
// hi-IN.js
help: {
  faq: "सामान्य प्रश्न",
  promo: "प्रमो",
  contactUs: "हमसे संपर्क करें",
  joinCommunity: "हमारे समुदाय से जुड़ें",
  help: "सहायता"
}
};
